import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SELECT_PLACING_PERIOD = 'PUBLISH_TERMS :: SELECT_PLACING_PERIOD';

export type TSelectPlacingPeriodAction = IReduxAction<typeof SELECT_PLACING_PERIOD, number>;

export const selectPlacingPeriod = actionGenerator<typeof SELECT_PLACING_PERIOD, number>(SELECT_PLACING_PERIOD);
